import React from "react";

export function HeroSection() {
  return (
    <section data-testid="hero-section" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/hero.jpg"
          alt="Morning Sunday Teer archery target at sunrise"
          className="w-full h-full object-cover object-right"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/10 sm:to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16 lg:py-20">
        <div className="max-w-xl">
          <h1 className="font-head font-black tracking-tight leading-[0.95]">
            <span className="block text-4xl sm:text-5xl lg:text-6xl brand-gradient-text">
              Morning
            </span>
            <span className="block text-4xl sm:text-5xl lg:text-6xl text-slate-900">
              Sunday Teer
            </span>
          </h1>
          <p className="mt-3 font-semibold text-slate-800 text-sm sm:text-base">
            Live Result • Previous Result • Common Number
          </p>
          <p className="mt-3 text-slate-600 text-sm sm:text-base max-w-md">
            Get the fastest and most accurate Morning Sunday Teer FR &amp; SR live update every day.
          </p>
        </div>
      </div>
    </section>
  );
}
